import { render, staticRenderFns } from "./active-button.vue?vue&type=template&id=248a8132&scoped=true&"
import script from "./active-button.vue?vue&type=script&lang=js&"
export * from "./active-button.vue?vue&type=script&lang=js&"
import style0 from "./active-button.vue?vue&type=style&index=0&id=248a8132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a8132",
  null
  
)

export default component.exports